/**
 * Configuración global de dayJS para la aplicación
 * Este archivo debe ser importado en main.ts para configurar dayJS antes de usar la aplicación
 */

// DayJS Core
import dayjs from 'dayjs';

// DayJS Plugins
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import isToday from 'dayjs/plugin/isToday';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';

// DayJS Locale
import 'dayjs/locale/es';

export function initializeDateConfiguration(): void {
  // Registrar plugins
  dayjs.extend(utc);
  dayjs.extend(timezone);
  dayjs.extend(customParseFormat);
  dayjs.extend(relativeTime);
  dayjs.extend(localizedFormat);
  dayjs.extend(isToday);
  dayjs.extend(isSameOrBefore);
  dayjs.extend(isSameOrAfter);

  // Default locale. A locale is Spanish month names, not a timezone: dates are painted in the
  // viewer's own timezone, and the app no longer declares a default zone of its own.
  dayjs.locale('es');
}
